import { HTTPError, ErrorResponse } from '../api/client'

export async function extractErrorMessage (err: unknown, fallback: string): Promise<string> {
  if (err instanceof HTTPError) {
    try {
      const errorData = await err.response.json() as ErrorResponse
      return errorData.error || fallback
    } catch {
      return fallback
    }
  }
  return err instanceof Error ? err.message : 'An error occurred'
}
